"use client"
import React from 'react';
import styled from 'styled-components';
import Modal from "react-bootstrap/Modal";
import {Col, Form, Row} from "react-bootstrap";
import 'simplebar-react/dist/simplebar.min.css';
import Button from "./ButtonV2";

const PopupV1 =({show,handleClose,pdf,title}) => {

    return (
        <StyledModal>
            <Modal show={show} className="cv-modal" onHide={handleClose}>
                <img className={'notice-bg'} src={'/images/static/notice-bg.jpg'}/>
                <Modal.Body>
                    <div className="modal-data d-flex align-items-center">
                        <Col md={{ span: 10, offset: 1 }} className="modal-data__content">

                            {/*<h3>Choose a division to continue</h3>*/}
                            {/*<p>Our operations are structured across dedicated divisions.*/}
                            {/*    Choose one to explore our services and projects.</p>*/}

                            <img className={'ucc-logo'} src={'/images/static/ucc-logo-white.svg'}/>

                            <Row>
                                <Col lg={3} md={6} >
                                    <Button
                                        src={'https://uccl.com.bd/'}
                                        hoverBorderColor={'rgb(25, 97, 172)'}
                                        background={'#221f1f'}
                                    border={'1px solid #FFF'}
                                            hoverBackground={'rgb(25, 97, 172)'}
                                            text={'Infrastructure Division'}
                                        margin={'0 0 30px 0'}
                                    />
                                </Col>
                                <Col lg={4} md={6} onClick={handleClose}>
                                    <Button
                                        hoverBorderColor={'rgb(25, 97, 172)'}
                                        background={'#221f1f'}
                                            border={'1px solid #FFF'}
                                            hoverBackground={'rgb(25, 97, 172)'}
                                            text={'Infratech Division'}/>
                                </Col>
                            </Row>


                        </Col>
                    </div>
                </Modal.Body>
            </Modal>
        </StyledModal>
    )
};


const StyledModal = styled.div`
    position: relative;
    overflow: hidden;

   

    .modal-dialog {
        margin: 0;
        position: relative;
    }

    h5 {
        color: #EDEEEF !important;
    }

    .footer__social {
        .col-sm-4 {
            min-width: 100%;
            justify-content: flex-start !important;

            &:nth-of-type(1) {
                display: none;
            }

            &:nth-last-of-type(1) {
                //display: none !important;
            }
        }
    }

`;


export default React.memo(PopupV1);
